import { createTheme } from "@mui/material";

export const rootTheme = {
  typography: {
    fontFamily: `'Manrope', sans-serif`,
    letterSpacing: 1.3,
    body1: {
      fontSize: 14
    },
    body2: {
      fontSize: 12
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          // filter: 'brightness(105%)',
          width: "100%"
        },
      },
    },

    // MuiCssBaseline: {
    //   styleOverrides: `
    //     @font-face {
    //       font-family: 'manrope';
    //       font-style: normal;
    //       font-display: swap;
    //       font-weight: 400;
    //       src: local('manrope'), local('manrope'), url(${manrope}) format('ttf');
    //       unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
    //     }
    //   `,
    // },
  },
};
export const appTheme = createTheme(rootTheme);
